
export const Persons = () => {
    return (
        <>
            <div className="team">
                <div className="persons">
                    <img src="/assets/images/faces/1.png" alt="" className="person" />
                    <img src="/assets/images/faces/2.png" alt="" className="person" />
                    <img src="/assets/images/faces/3.png" alt="" className="person" />
                    <img src="/assets/images/faces/4.png" alt="" className="person" />
                    <img src="/assets/images/faces/5.png" alt="" className="person" />
                    <img src="/assets/images/faces/6.png" alt="" className="person" />
                </div>
                <div>+15 persons more </div>
            </div>
        </>
    )
}